import {
    colors,
    LanguageCode,
    prepChecksLearnMoreURL,
} from '@hazadapt-git/public-core-base'
import { Close } from '@mui/icons-material'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    DialogActions,
    Button,
    Link,
} from '@mui/material'
import React, { FC } from 'react'

import { prepCheckWelcomeText, PrepCheckWelcomeTextConfig } from '../../i18n'
import { Markdown } from '../atoms'
import { useAppSelector } from '../../lib/store'
import { selectUser } from '../../lib/slices'
import { shallowEqual } from 'react-redux'

interface PrepCheckWelcomeModalProps {
    open: boolean
    onClose: React.MouseEventHandler
    onSignUpClick: () => void
    lang?: LanguageCode
}

export const PrepCheckWelcomeModal: FC<PrepCheckWelcomeModalProps> = (
    props: PrepCheckWelcomeModalProps
) => {
    const user = useAppSelector(selectUser, shallowEqual)
    const modalConfig: PrepCheckWelcomeTextConfig | undefined =
        prepCheckWelcomeText.get(props.lang ?? LanguageCode.ENGLISH)

    return modalConfig ? (
        <Dialog
            open={props.open}
            PaperProps={{ sx: { maxHeight: '80vh', padding: '0.5rem 0' } }}
        >
            <DialogTitle sx={{ textAlign: 'center' }}>
                <Markdown
                    content={modalConfig.title}
                    styleOverrides={{
                        h3: { color: colors.primary.HELIOTROPE },
                    }}
                />
            </DialogTitle>
            <DialogContent>
                <IconButton
                    onClick={props.onClose}
                    sx={{
                        position: 'absolute',
                        top: '0.5rem',
                        right: '0.5rem',
                    }}
                >
                    <Close />
                </IconButton>
                <Markdown content={modalConfig.blurbChunk1} />
                <Markdown content={modalConfig.blurbChunk2} />
                {modalConfig.aspectDisplay}
                <Markdown content={modalConfig.blurbChunk3} />

                <Link href={prepChecksLearnMoreURL} target="_blank">
                    <Markdown content={modalConfig.learnMoreBlurb} />
                </Link>

                {!user && (
                    <Markdown
                        content={modalConfig.guestModeBlurb}
                        styleOverrides={{
                            strong: { color: colors.primary.HELIOTROPE },
                        }}
                    />
                )}
            </DialogContent>
            <DialogActions sx={{ margin: '0.5rem 0.5rem 0' }}>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: user ? 'flex-end' : 'space-evenly',
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: colors.primary.HELIOTROPE }}
                        onClick={props.onClose}
                    >
                        {modalConfig.continueCta}
                    </Button>
                    {!user && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={props.onSignUpClick}
                        >
                            {modalConfig.signupCta}
                        </Button>
                    )}
                </div>
            </DialogActions>
        </Dialog>
    ) : null
}
